import Swal from "sweetalert2";

const showOldRequirementPopup = (requirements) => {

  if (!requirements || requirements.length === 0) return;

  const rows = requirements
    .map((req) => {

      const formattedDate = req.createdDate
        ? new Date(req.createdDate).toLocaleDateString("en-GB")
        : "-";

      return `
        <tr>

          <td style="padding:8px;border:1px solid #ddd;">
            ${req.jobReqId}
          </td>

          <td style="padding:8px;border:1px solid #ddd;">
            ${req.companyName}
          </td>

          <td style="padding:8px;border:1px solid #ddd;">
            ${req.jobTitle}
          </td>

          <td style="padding:8px;border:1px solid #ddd;">
            ${formattedDate}
          </td>

          <td style="padding:8px;border:1px solid #ddd;">
             ${req.jobAge}
          </td>

          <td style="padding:8px;border:1px solid #ddd;">
            <span style="
              padding:4px 10px;
              border-radius:5px;
              color:white;
              background:${req.jobReqStatus === "Open"
          ? "#28a745"
          : "#ff9800"
        };
            ">
              ${req.jobReqStatus}
            </span>
          </td>

        </tr>
      `;
    })
    .join("");

  return Swal.fire({

    title: "⚠️ Old Job Requirements Alert",
    width: "1000px",

    html: `
      <div style="max-height:400px;overflow:auto;">

        <p style="
          margin-bottom:15px;
          font-size:15px;
        ">
          These requirements are older than 15 days
          and still in Open/Freeze status.
        </p>
        <div style="
  background:#fff3cd;
  color:#856404;
  border:1px solid #ffeeba;
  padding:12px;
  border-radius:8px;
  margin-bottom:18px;
  font-weight:600;
  text-align:center;
">
  Kindly close all these requirements ASAP.
</div>

        <table style="
          width:100%;
          border-collapse:collapse;
          font-size:14px;
        ">

          <thead>

            <tr style="background:#f5f5f5;">

              <th style="padding:10px;border:1px solid #ddd;">
                Job Req ID
              </th>

              <th style="padding:10px;border:1px solid #ddd;">
                Company Name
              </th>

              <th style="padding:10px;border:1px solid #ddd;">
                Job Title
              </th>

              <th style="padding:10px;border:1px solid #ddd;">
                Created Date
              </th>
              <th style="padding:10px;border:1px solid #ddd;">
  Job Age
</th>
              <th style="padding:10px;border:1px solid #ddd;">
                Status
              </th>

            </tr>

          </thead>

          <tbody>
            ${rows}
          </tbody>

        </table>

      </div>
    `,

    confirmButtonText: "OK",

    confirmButtonColor: "#3085d6",

  });

};

export default showOldRequirementPopup;